<template>
  <base-page-layout title="Gerenciamento de clientes">
    <mf-tabs-menu v-model="currentTab" class="mb-5" :tabs="permissionedCustomerManagementTabs" :tabs-errors="tabsErrors" />
    <router-view />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { QUERY_GET_TOTAL_USERS_PENDING_DELETE_DATA_REQUEST } from '@/modules/clientes/gerenciamento/graphql'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GerenciamentoClientes',
  components: {
    BasePageLayout,
  },
  data: () => ({
    currentTab: null,
    totalDeleteDataRequests: 0,
  }),
  computed: {
    ...mapGetters(['platformNotifications']),
    tabsErrors() {
      if (this.platformNotifications?.PENDING_USER_DELETE_DATA_REQUESTS?.entities_amount) {
        return [1]
      }
      return []
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    customerManagementTabs() {
      return [
        {
          name: 'Cadastros',
          to: '/clientes/gerenciamento/cadastros',
          tabPermission: 'clientes/gerenciamento/cadastros/visualizar-cadastros',
        },
        {
          name: `Solicitações (${this.totalDeleteDataRequests})`,
          to: '/clientes/gerenciamento/solicitacoes',
          tabPermission: 'clientes/gerenciamento/solicitacoes',
        },
      ]
    },
    permissionedCustomerManagementTabs() {
      let tabs = []
      this.customerManagementTabs.forEach((tab) => {
        if (this.$permissions.havePagePermission(tab.tabPermission)) {
          tabs.push(tab)
        }
      })
      return tabs
    },
  },
  watch: {
    currentTab(tab) {
      if (this.$route.path !== this.permissionedCustomerManagementTabs[tab].to) {
        this.$router.push(this.permissionedCustomerManagementTabs[tab].to)
      }
    },
    tabs() {
      const tabs = [
        {
          name: 'Cadastros',
          itemsLength: 0,
          haveLength: false,
        },
      ]
      if (!this.isFranchisee) {
        tabs.push({
          name: 'Solicitações',
          itemsLength: this.totalDeleteDataRequests,
          haveLength: true,
        })
      }
      return tabs
    },
  },
  mounted() {
    this.updateTotalDeleteDataRequest()
    if (this.$getAllowedModules()['dynamic_attributes']) {
      this.queryDynamicAttributes()
    }
    this.setInitialTab()
  },
  beforeUpdate() {
    this.setInitialTab()
  },
  methods: {
    ...mapActions(['queryDynamicAttributes']),
    setInitialTab() {
      if (this.$route.path === '/clientes/gerenciamento') {
        this.$router.push(this.permissionedCustomerManagementTabs[0].to)
        this.currentTab = 0
        return
      }
      const index = this.permissionedCustomerManagementTabs.findIndex((p) => p.to === this.$route.path)
      this.currentTab = index === -1 ? 0 : index
    },
    setTotalDeleteDataRequest(total) {
      this.totalDeleteDataRequests = total
    },

    async updateTotalDeleteDataRequest() {
      try {
        const {
          data: { usersPendingDeleteDataRequest },
        } = await this.$apollo.query({
          query: QUERY_GET_TOTAL_USERS_PENDING_DELETE_DATA_REQUEST,
          variables: {
            page: 1,
            pageSize: 1,
          },
          fetchPolicy: 'no-cache',
        })

        this.setTotalDeleteDataRequest(usersPendingDeleteDataRequest?.records)
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      }
    },
  },
}
</script>
